import { render, staticRenderFns } from "./printerRuleRepair.vue?vue&type=template&id=2f5dc642&scoped=true"
import script from "./printerRuleRepair.vue?vue&type=script&lang=js"
export * from "./printerRuleRepair.vue?vue&type=script&lang=js"
import style0 from "./printerRuleRepair.vue?vue&type=style&index=0&id=2f5dc642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dc642",
  null
  
)

export default component.exports